import { TOption } from '../../form/MultySelect/MultySelect';
import { TLanguage } from '../../../types';

export type IConfigOption = {
  [key in TLanguage]: TOption[];
};

export const mainIngredients: IConfigOption = {
  eng: [
    { value: 'Rum', label: 'Rum' },
    { value: 'Gin', label: 'Gin' },
    { value: 'Brandy', label: 'Brandy' },
    { value: 'Whiskey', label: 'Whiskey' },
    { value: 'Tequila', label: 'Tequila' },
    { value: 'Vodka', label: 'Vodka' },
    { value: 'Other', label: 'Other' },
    { value: 'Wine', label: 'Wine' },
  ],
  ru: [
    { value: 'Ром', label: 'Ром' },
    { value: 'Джин', label: 'Джин' },
    { value: 'Бренди', label: 'Бренди' },
    { value: 'Виски', label: 'Виски' },
    { value: 'Текила', label: 'Текила' },
    { value: 'Водка', label: 'Водка' },
    { value: 'Другое', label: 'Другое' },
    { value: 'Вино', label: 'Вино' },
  ],
};

export const categoryList: IConfigOption = {
  eng: [
    { value: 'Simple', label: 'Simple' },
    { value: 'Classic', label: 'Classic' },
    { value: 'Long', label: 'Long' },
    { value: 'Short', label: 'Short' },
    { value: 'Creamy', label: 'Creamy' },
    { value: 'Sparkling', label: 'Sparkling' },
    { value: 'Tropical', label: 'Tropical' },
    { value: 'Fruit & Herb', label: 'Fruit & Herb' },
    { value: 'Sour', label: 'Sour' },
    { value: 'Savory', label: 'Savory' },
    { value: 'Warming', label: 'Warming' },
    { value: 'Low-proof', label: 'Low-proof' },
    { value: 'Spirit-forward', label: 'Spirit-forward' },
    { value: 'Spicy', label: 'Spicy' },
    { value: 'Bitter', label: 'Bitter' },
    { value: 'Sweet', label: 'Sweet' },
  ],
  ru: [
    { value: 'Простые', label: 'Простые' },
    { value: 'Классические', label: 'Классические' },
    { value: 'Лонг дринк', label: 'Лонг дринк' },
    { value: 'Шорт дринк', label: 'Шорт дринк' },
    { value: 'Сливочные', label: 'Сливочные' },
    { value: 'Игристрые', label: 'Игристрые' },
    { value: 'Тропические', label: 'Тропические' },
    { value: 'Фруктовые и травяные', label: 'Фруктовые и травяные' },
    { value: 'Кислые', label: 'Кислые' },
    { value: 'Пряные', label: 'Пряные' },
    { value: 'Согревающие', label: 'Согревающие' },
    { value: 'Слабоалкогольные', label: 'Слабоалкогольные' },
    { value: 'Крепкие', label: 'Крепкие' },
    { value: 'Острые', label: 'Острые' },
    { value: 'Горькие', label: 'Горькие' },
    { value: 'Сладкие', label: 'Сладкие' },
  ],
};

export const tasties: IConfigOption = {
  eng: [
    { value: 'Sour', label: 'Sour' },
    { value: 'Fruity', label: 'Fruity' },
    { value: 'Sweet', label: 'Sweet' },
    { value: 'Bitter', label: 'Bitter' },
    { value: 'Dry', label: 'Dry' },
    { value: 'Mineral', label: 'Mineral' },
    { value: 'Fresh', label: 'Fresh' },
    { value: 'Citrus', label: 'Citrus' },
    { value: 'Creamy', label: 'Creamy' },
    { value: 'Coffee', label: 'Coffee' },
    { value: 'Savory', label: 'Savory' },
    { value: 'Berry', label: 'Berry' },
    { value: 'Stone', label: 'Stone' },
    { value: 'Honey', label: 'Honey' },
    { value: 'Tart', label: 'Tart' },
    { value: 'Mint', label: 'Mint' },
    { value: 'Cocoa', label: 'Cocoa' },
    { value: 'Tomato', label: 'Tomato' },
    { value: 'Sweet-and-sour', label: 'Sweet-and-sour' },
    { value: 'Spicy', label: 'Spicy' },
    { value: 'Nutty', label: 'Nutty' },
    { value: 'Floral', label: 'Floral' },
    { value: 'Herbal', label: 'Herbal' },
    { value: 'Tropical', label: 'Tropical' },
    { value: 'Warm', label: 'Warm' },
    { value: 'Ginger', label: 'Ginger' },
    { value: 'Lemon', label: 'Lemon' },
    { value: 'Mild', label: 'Mild' },
    { value: 'Fragnat', label: 'Fragnat' },
    { value: 'Orange', label: 'Orange' },
    { value: 'Aniseed', label: 'Aniseed' },
    { value: 'Wine', label: 'Wine' },
    { value: 'Dried fruits', label: 'Dried fruits' },
    { value: 'Strong', label: 'Strong' },
    { value: 'Coconut', label: 'Coconut' },
    { value: 'Rasberry', label: 'Rasberry' },
    { value: 'Grapefruit', label: 'Grapefruit' },
    { value: 'Iodide', label: 'Iodide' },
    { value: 'Salty', label: 'Salty' },
    { value: 'Beer', label: 'Beer' },
  ],
  ru: [
    { value: 'Кислый', label: 'Кислый' },
    { value: 'Фруктовый', label: 'Фруктовый' },
    { value: 'Сладкий', label: 'Сладкий' },
    { value: 'Горький', label: 'Горький' },
    { value: 'Сухой', label: 'Сухой' },
    { value: 'Минеральный', label: 'Минеральный' },
    { value: 'Свежий', label: 'Свежий' },
    { value: 'Цитрусовый', label: 'Цитрусовый' },
    { value: 'Сливочный', label: 'Сливочный' },
    { value: 'Кофейный', label: 'Кофейный' },
    { value: 'Пряный', label: 'Пряный' },
    { value: 'Ягодный', label: 'Ягодный' },
    { value: 'Косточковый', label: 'Косточковый' },
    { value: 'Медовый', label: 'Медовый' },
    { value: 'Терпкий', label: 'Терпкий' },
    { value: 'Мятный', label: 'Мятный' },
    { value: 'Какао', label: 'Какао' },
    { value: 'Томатный', label: 'Томатный' },
    { value: 'Кисло-сладкий', label: 'Кисло-сладкий' },
    { value: 'Острый', label: 'Острый' },
    { value: 'Ореховый', label: 'Ореховый' },
    { value: 'Цветочный', label: 'Цветочный' },
    { value: 'Травяной', label: 'Травяной' },
    { value: 'Тропический', label: 'Тропический' },
    { value: 'Теплый', label: 'Теплый' },
    { value: 'Имбирный', label: 'Имбирный' },
    { value: 'Лимонный', label: 'Лимонный' },
    { value: 'Мягкий', label: 'Мягкий' },
    { value: 'Ароматный', label: 'Ароматный' },
    { value: 'Апельсиновый', label: 'Апельсиновый' },
    { value: 'Анисовый', label: 'Анисовый' },
    { value: 'Винный', label: 'Винный' },
    { value: 'Сухофрукты', label: 'Сухофрукты' },
    { value: 'Крепкий', label: 'Крепкий' },
    { value: 'Кокосовый', label: 'Кокосовый' },
    { value: 'Малиновый', label: 'Малиновый' },
    { value: 'Грейпфрут', label: 'Грейпфрут' },
    { value: 'Йодистый', label: 'Йодистый' },
    { value: 'Соленый', label: 'Соленый' },
    { value: 'Пивной', label: 'Пивной' },
  ],
};

export const tools: IConfigOption = {
  eng: [
    { value: 'Mixing glass', label: 'Mixing glass' },
    { value: 'Strainer', label: 'Strainer' },
    { value: 'Jigger', label: 'Jigger' },
    { value: 'Barspoon', label: 'Barspoon' },
    { value: 'Boston shaker', label: 'Boston shaker' },
    { value: 'Cobbler shaker', label: 'Cobbler shaker' },
    { value: 'Muddler', label: 'Muddler' },
  ],
  ru: [
    { value: 'Смесительный стакан', label: 'Смесительный стакан' },
    { value: 'Стрейнер', label: 'Стрейнер' },
    { value: 'Джиггер', label: 'Джиггер' },
    { value: 'Барная ложка', label: 'Барная ложка' },
    { value: 'Бостон шейкер', label: 'Бостон шейкер' },
    { value: 'Коблер шейкер', label: 'Коблер шейкер' },
    { value: 'Мадлер', label: 'Мадлер' },
  ],
};

export const addTools: IConfigOption = {
  eng: [
    { value: 'Ice scoop', label: 'Ice scoop' },
    { value: 'Tweezer', label: 'Tweezer' },
    { value: 'Zester', label: 'Zester' },
    { value: 'Fine strainer', label: 'Fine strainer' },
    { value: 'Knife', label: 'Knife' },
    { value: 'Squeezer', label: 'Squeezer' },
    { value: 'Swizzle stick', label: 'Swizzle stick' },
    { value: 'Grater', label: 'Grater' },
    { value: 'Lighter', label: 'Lighter' },
    { value: 'Skewer', label: 'Skewer' },
    { value: 'Ice tongs', label: 'Ice tongs' },
    { value: 'Dropper', label: 'Dropper' },
    { value: 'Spray', label: 'Spray' },
  ],
  ru: [
    { value: 'Совок для льда', label: 'Совок для льда' },
    { value: 'Пинцет', label: 'Пинцет' },
    { value: 'Нож для цедры', label: 'Нож для цедры' },
    { value: 'Барное сито', label: 'Барное сито' },
    { value: 'Нож', label: 'Нож' },
    { value: 'Сквизер', label: 'Сквизер' },
    { value: 'Свизл-стик', label: 'Свизл-стик' },
    { value: 'Терка', label: 'Терка' },
    { value: 'Зажигалка', label: 'Зажигалка' },
    { value: 'Шпажка', label: 'Шпажка' },
    { value: 'Щипцы для льда', label: 'Щипцы для льда' },
    { value: 'Пипетка', label: 'Пипетка' },
    { value: 'Спрей', label: 'Спрей' },
  ],
};

export const volumeOptions: IConfigOption = {
  eng: [
    { value: 'Long Drink', label: 'Long Drink' },
    { value: 'Short Drink', label: 'Short Drink' },
    { value: 'Shot Drink', label: 'Shot Drink' },
  ],
  ru: [
    { value: 'Лонг Дринк', label: 'Лонг Дринк' },
    { value: 'Шорт Дринк', label: 'Шорт Дринк' },
    { value: 'Шоты', label: 'Шоты' },
  ],
};

export const methodMaking: IConfigOption = {
  eng: [
    { value: 'Build', label: 'Build' },
    { value: 'Stir', label: 'Stir' },
    { value: 'Shake', label: 'Shake' },
    { value: 'Swizzle', label: 'Swizzle' },
    { value: 'Rolling', label: 'Rolling' },
    { value: 'Layering', label: 'Layering' },
    { value: 'Muddling', label: 'Muddling' },
    { value: 'Flaming', label: 'Flaming' },
  ],
  ru: [
    { value: 'Билд', label: 'Билд' },
    { value: 'Шейк', label: 'Шейк' },
    { value: 'Стир', label: 'Стир' },
    { value: 'Роллинг', label: 'Роллинг' },
    { value: 'Свизл', label: 'Свизл' },
    { value: 'Лейринг', label: 'Лейринг' },
    { value: 'Мадлинг', label: 'Мадлинг' },
    { value: 'Флейминг', label: 'Флейминг' },
  ],
};

export const garnishList: IConfigOption = {
  eng: [
    { value: 'Lime wedge', label: 'Lime wedge' },
    { value: 'Lime slice', label: 'Lime slice' },
    { value: 'Lemon twist', label: 'Lemon twist' },
    { value: 'Lemon slice', label: 'Lemon slice' },
    { value: 'Orange twist', label: 'Orange twist' },
    { value: 'Orange slice', label: 'Orange slice' },
    { value: 'Green olive', label: 'Green olive' },
    { value: 'Maraschino cherry', label: 'Maraschino cherry' },
    { value: 'Coffee beans', label: 'Coffee beans' },
    { value: 'Mint', label: 'Mint' },
    { value: 'Nutmeg', label: 'Nutmeg' },
    { value: 'Celery', label: 'Celery' },
    { value: 'Pineapple leaf', label: 'Pineapple leaf' },
    { value: 'Pineapple wedge', label: 'Pineapple wedge' },
    { value: 'Cocktail onion', label: 'Cocktail onion' },
    { value: 'Cinnamon Stick', label: 'Cinnamon Stick' },
    { value: 'Raspberry', label: 'Raspberry' },
    { value: 'Blackberry', label: 'Blackberry' },
    { value: 'Kosher salt rim', label: 'Kosher salt rim' },
    { value: 'Lemon wedge', label: 'Lemon wedge' },
  ],
  ru: [
    { value: 'Долька лайма', label: 'Долька лайма' },
    { value: 'Слайс лайма', label: 'Слайс лайма' },
    { value: 'Твист лимона', label: 'Твист лимона' },
    { value: 'Слайс лимона', label: 'Слайс лимона' },
    { value: 'Твист апельсина', label: 'Твист апельсина' },
    { value: 'Слайс апельсина', label: 'Слайс апельсина' },
    { value: 'Зеленая оливка', label: 'Зеленая оливка' },
    { value: 'Вишня Мараскино', label: 'Вишня Мараскино' },
    { value: 'Кофейные зерна', label: 'Кофейные зерна' },
    { value: 'Мята', label: 'Мята' },
    { value: 'Мускатный орех', label: 'Мускатный орех' },
    { value: 'Сельдерей', label: 'Сельдерей' },
    { value: 'Ананасовый лист', label: 'Ананасовый лист' },
    { value: 'Долька ананаса', label: 'Долька ананаса' },
    { value: 'Коклейльный лук', label: 'Коклейльный лук' },
    { value: 'Палочка корицы', label: 'Палочка корицы' },
    { value: 'Малина', label: 'Малина' },
    { value: 'Ежевика', label: 'Ежевика' },
    { value: 'Краста из соли', label: 'Краста из соли' },
    { value: 'Долька лимона', label: 'Долька лимона' },
  ],
};

export const typesOfIce: IConfigOption = {
  eng: [
    { value: 'Crushed ice', label: 'Crushed ice' },
    { value: 'Ice cubes', label: 'Ice cubes' },
    { value: 'Ice block', label: 'Ice block' },
  ],
  ru: [
    { value: 'Лёд фраппе', label: 'Лёд фраппе' },
    { value: 'Лёд в кубиках', label: 'Лёд в кубиках' },
    { value: 'Глыба льда', label: 'Глыба льда' },
  ],
};

export const complexityList: IConfigOption = {
  eng: [
    { value: 'Easy', label: 'Easy' },
    { value: 'Medium', label: 'Medium' },
    { value: 'Hard', label: 'Hard' },
  ],
  ru: [
    { value: 'Легкий', label: 'Легкий' },
    { value: 'Средний', label: 'Средний' },
    { value: 'Сложный', label: 'Сложный' },
  ],
};

export const countries: IConfigOption = {
  eng: [
    { value: 'France', label: 'France' },
    { value: 'Italy', label: 'Italy' },
    { value: 'USA', label: 'USA' },
    { value: 'Cuba', label: 'Cuba' },
    { value: 'UK', label: 'UK' },
    { value: 'Mexico', label: 'Mexico' },
    { value: 'Singapore', label: 'Singapore' },
    { value: 'Australia', label: 'Australia' },
    { value: 'Ireland', label: 'Ireland' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Peru', label: 'Peru' },
    { value: 'Brazil', label: 'Brazil' },
    { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
    { value: 'Bermuda', label: 'Bermuda' },
    { value: 'Puerto Rico', label: 'Puerto Rico' },
  ],
  ru: [
    { value: 'France', label: 'Франция' },
    { value: 'Italy', label: 'Италия' },
    { value: 'USA', label: 'США' },
    { value: 'Cuba', label: 'Куба' },
    { value: 'UK', label: 'Великобритания' },
    { value: 'Mexico', label: 'Мексика' },
    { value: 'Singapore', label: 'Сингапур' },
    { value: 'Australia', label: 'Австралия' },
    { value: 'Ireland', label: 'Ирландия' },
    { value: 'Belgium', label: 'Бельгия' },
    { value: 'Peru', label: 'Перу' },
    { value: 'Brazil', label: 'Бразилия' },
    { value: 'Trinidad and Tobago', label: 'Тринидад и Тобаго' },
    { value: 'Bermuda', label: 'Бермуды' },
    { value: 'Puerto Rico', label: 'Пуэрто-Рико' },
  ],
};

export const strengthList: IConfigOption = {
  eng: [
    { value: 'Light', label: 'Light' },
    { value: 'Medium', label: 'Medium' },
    { value: 'Strong', label: 'Strong' },
  ],
  ru: [
    { value: 'Легкий', label: 'Легкий' },
    { value: 'Средний', label: 'Средний' },
    { value: 'Крепкий', label: 'Крепкий' },
  ],
};

export const timeForCocktailList: IConfigOption = {
  eng: [
    { value: 'Anytime drink', label: 'Anytime drink' },
    { value: 'Aperitif', label: 'Aperitif' },
    { value: 'Digestif', label: 'Digestif' },
    { value: 'Night', label: 'Night' },
    { value: 'Breakfast', label: 'Breakfast' },
    { value: 'Lunch', label: 'Lunch' },
    { value: 'Evening', label: 'Evening' },
    { value: 'Dessert', label: 'Dessert' },
    { value: 'Hangover', label: 'Hangover' },
    { value: 'Party', label: 'Party' },
  ],
  ru: [
    { value: 'В любое время', label: 'В любое время' },
    { value: 'Аперитив', label: 'Аперитив' },
    { value: 'Дижестив', label: 'Дижестив' },
    { value: 'Ночь', label: 'Ночь' },
    { value: 'Завтрак', label: 'Завтрак' },
    { value: 'Обед', label: 'Обед' },
    { value: 'Вечер', label: 'Вечер' },
    { value: 'Десертный', label: 'Десертный' },
    { value: 'Похмельный', label: 'Похмельный' },
    { value: 'Вечеринка', label: 'Вечеринка' },
  ],
};

export const glasswareOptions: IConfigOption = {
  eng: [
    { value: 'Rocks glass', label: 'Rocks glass' },
    { value: 'Cocktail glass', label: 'Cocktail glass' },
    { value: 'Flute glass', label: 'Flute glass' },
    { value: 'Wine glass', label: 'Wine glass' },
    { value: 'Highball', label: 'Highball' },
    { value: 'Julep glass', label: 'Julep glass' },
    { value: 'Hurricane glass', label: 'Hurricane glass' },
    { value: 'Champagne glass', label: 'Champagne glass' },
    { value: 'Tiki mug', label: 'Tiki mug' },
    { value: 'Irish coffee glass', label: 'Irish coffee glass' },
    { value: 'Moscow Mule mug', label: 'Moscow Mule mug' },
    { value: 'Shot glass', label: 'Shot glass' },
    { value: 'Beer glass', label: 'Beer glass' },
  ],
  ru: [
    { value: 'Стакан Рокс', label: 'Стакан Рокс' },
    { value: 'Коктейльная рюмка', label: 'Коктейльная рюмка' },
    { value: 'Бокал Флюте', label: 'Бокал Флюте' },
    { value: 'Винный бокал', label: 'Винный бокал' },
    { value: 'Хайбол', label: 'Хайбол' },
    { value: 'Джулеп бокал', label: 'Джулеп бокал' },
    { value: 'Бокал Харрикейн', label: 'Бокал Харрикейн' },
    { value: 'Бокал для шампанского', label: 'Бокал для шампанского' },
    { value: 'Тики бокал', label: 'Тики бокал' },
    { value: 'Бокал Айриш кофе', label: 'Бокал Айриш кофе' },
    { value: 'Кружка Московский мул', label: 'Кружка Московский мул' },
    { value: 'Стопка', label: 'Стопка' },
    { value: 'Пивной бокал', label: 'Пивной бокал' },
  ],
};

export const accessOptions: IConfigOption = {
  eng: [
    { value: 'PUBLIC', label: 'PUBLIC' },
    { value: 'SUBSCRIBTION', label: 'SUBSCRIBTION' },
    { value: 'ADS', label: 'ADS' },
    { value: 'DEV', label: 'DEV' },
    { value: 'HIDDEN', label: 'HIDDEN' },
  ],
  ru: [
    { value: 'PUBLIC', label: 'PUBLIC' },
    { value: 'SUBSCRIBTION', label: 'SUBSCRIBTION' },
    { value: 'ADS', label: 'ADS' },
    { value: 'DEV', label: 'DEV' },
    { value: 'HIDDEN', label: 'HIDDEN' },
  ],
};

export const colorOption: IConfigOption = {
  eng: [
    { value: 'Green', label: 'Green' },
    { value: 'Red', label: 'Red' },
    { value: 'Beige', label: 'Beige' },
    { value: 'Black', label: 'Black' },
    { value: 'Orange', label: 'Orange' },
    { value: 'Yellow', label: 'Yellow' },
    { value: 'White', label: 'White' },
    { value: 'Brown', label: 'Brown' },
    { value: 'Pink', label: 'Pink' },
    { value: 'Transparent', label: 'Transparent' },
    { value: 'Light blue', label: 'Light blue' },
    { value: 'Burgundy', label: 'Burgundy' },
    { value: 'Caramel', label: 'Caramel' },
    { value: 'Multicolored', label: 'Multicolored' },
  ],
  ru: [
    { value: 'Зеленый', label: 'Зеленый' },
    { value: 'Красный', label: 'Красный' },
    { value: 'Бежевый', label: 'Бежевый' },
    { value: 'Черный', label: 'Черный' },
    { value: 'Оранжевый', label: 'Оранжевый' },
    { value: 'Желтый', label: 'Желтый' },
    { value: 'Белый', label: 'Белый' },
    { value: 'Коричневый', label: 'Коричневый' },
    { value: 'Розовый', label: 'Розовый' },
    { value: 'Прозрачный', label: 'Прозрачный' },
    { value: 'Голубой', label: 'Голубой' },
    { value: 'Бордовый', label: 'Бордовый' },
    { value: 'Карамельный', label: 'Карамельный' },
    { value: 'Разноцветный', label: 'Разноцветный' },
  ],
};

export const typeServing: IConfigOption = {
  eng: [
    { value: 'On the rocks', label: 'On the rocks' },
    { value: 'Up', label: 'Up' },
    { value: 'Crashed ice', label: 'Crashed ice' },
  ],
  ru: [
    { value: 'Со льдом', label: 'Со льдом' },
    { value: 'Без льда', label: 'Без льда' },
    { value: 'Лёд фраппе', label: 'Лёд фраппе' },
  ],
};

export const group: IConfigOption = {
  eng: [
    { value: 'Variation', label: 'Variation' },
    { value: 'Classic', label: 'Classic' },
    { value: 'Tiki', label: 'Tiki' },
    { value: 'Modern Classic', label: 'Modern Classic' },
    { value: 'New Era', label: 'New Era' },
    { value: 'Unforgettable', label: 'Unforgettable' },
  ],
  ru: [
    { value: 'Вариация', label: 'Вариация' },
    { value: 'Классический', label: 'Классический' },
    { value: 'Тики', label: 'Тики' },
    { value: 'Современная классика', label: 'Современная классика' },
    { value: 'Новая Эра', label: 'Новая Эра' },
    { value: 'Незабываемые', label: 'Незабываемые' },
  ],
};

export const cookingStepExample = `[
  {
       "time": 0,
       "description": [
            {
                 "value": "Fill a "
            },
            {
                 "value": "Rocks glass with ice",
                 "isMarked": true
            },
            {
                 "value": ", drop a ",
                 "isMarked": true
            },
            {
                 "value": "Lime wedge"
            }
       ]
  },
  {
       "time": 8,
       "description": [
            {
                 "value": "Pour in "
            },
            {
                 "value": "50 ",
                 "isMarked": true,
                 "isCount": true
            },
            {
                 "value": "ml ",
                 "isMarked": true,
                 "isUnit": true
            },
            {
                 "value": "Rum",
                 "isMarked": true
            }
       ]
  }
]`;

export const fieldPlaceholder = {
  name: { eng: 'Name', ru: 'Название' },
  indexName: {
    eng: 'ID',
    ru: 'ID',
  },
  baseSpirit: {
    eng: 'Base spirit',
    ru: 'Основной ингредиент',
  },
  category: {
    eng: 'Category',
    ru: 'Категория',
  },
  ingredients: {
    eng: 'Ingredients',
    ru: 'Ингредиенты',
  },
  degrees: {
    eng: 'Degree',
    ru: 'Градус',
  },
  strength: {
    eng: 'Strength',
    ru: 'Крепость',
  },
  taste: {
    eng: 'Flavor',
    ru: 'Вкус',
  },
  access: {
    eng: 'Access',
    ru: 'Доступ',
  },
  tools: {
    eng: 'Tools',
    ru: 'Инструменты',
  },
  addTools: {
    eng: 'Additional tools',
    ru: 'Доп. инструменты',
  },
  glass: {
    eng: 'Glassware',
    ru: 'Посуда',
  },
  volume: {
    eng: 'Size',
    ru: 'Объем',
  },
  typeServing: {
    eng: 'Serving',
    ru: 'Способ подачи',
  },
  group: {
    eng: 'Group',
    ru: 'Группа',
  },
  method: {
    eng: 'Method of making',
    ru: 'Способ приготовления',
  },
  color: {
    eng: 'Color',
    ru: 'Цвет',
  },
  garnish: {
    eng: 'Garnish',
    ru: 'Гарнир',
  },
  typesOfIce: {
    eng: 'Type of ice',
    ru: 'Тип льда',
  },
  difficulty: {
    eng: 'Difficulty',
    ru: 'Сложность',
  },
  country: {
    eng: 'Country',
    ru: 'Страна',
  },
  origin: {
    eng: 'Origin',
    ru: 'Источник',
  },
  timeForCocktail: {
    eng: 'Time for cocktail',
    ru: 'Время употребления',
  },
  vegan: {
    eng: 'Vegan',
    ru: 'Вегетарианский',
  },
  cookingSteps: {
    eng: 'Cooking steps',
    ru: 'Шаги приготовления',
  },
  description: {
    eng: 'Description',
    ru: 'Описание',
  },
};
